import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#e53935', // Update this to match your logo's primary color
    },
    secondary: {
      main: '#ff4081', // Adjust if needed to match secondary color
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
});

export default theme;
